import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 償却状況 */
enum DepreciationStatus {
  depreciating = '1',
  residualAchievement = '2',
  residualDepreciation = '3',
  depreciationComplete = '4',
}

const nameConfig = {
  depreciating: new Map([
    [Locale.ja, '償却中'],
    [Locale.en, 'Depreciating'],
  ]),
  residualAchievement: new Map([
    [Locale.ja, '残存到達'],
    [Locale.en, 'Residual Achievement'],
  ]),
  residualDepreciation: new Map([
    [Locale.ja, '残存償却'],
    [Locale.en, 'Residual Depreciation'],
  ]),
  depreciationComplete: new Map([
    [Locale.ja, '償却完了'],
    [Locale.en, 'Depreciation Complete'],
  ]),
};

const toEnum = rawValueToEnum(DepreciationStatus, DepreciationStatus.depreciating);
const toDisplay = enumToName(DepreciationStatus, nameConfig);
const toDisplayWithPrefix = enumToName(DepreciationStatus, nameConfig, { prefix: true });

export const depreciationStatus = {
  enum: DepreciationStatus,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { DepreciationStatus };
